module.exports = "/assets/57f4c4f7946ee591b535a95f34fdfc0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/P3.png
// module id = 1702
// module chunks = 0